module.exports = __webpack_public_path__ + "static/media/apple_btn.b5622822.png";